module.exports = __webpack_public_path__ + "img/mine.ec773b00.png";